import * as React  from 'react';
import '../../inCss/Card.css';
import { Link } from 'react-router-dom';

export interface DownloadProps {
    buttonText: string;
    userName: string;
    eSIMNumber: string;
    eidNumber: string;
    clickEvt: () => void;
    doLogout: () => void;
}

export const DownloadCard: React.StatelessComponent<DownloadProps> = (props) => {

    const urlToNavigate = `/app?eid=${props.eidNumber}`;
    return (
        <div className="card">
            <div className="card-body">
                <p className="card-text">
                     <span id="uName">Hi {props.userName}</span> &nbsp; <span className="text-muted">|</span> &nbsp; 
                    <Link to={urlToNavigate} id="logout" onClick={() => props.doLogout()}>Signout </Link>
                </p>
                <h5 className="card-title" id="pageTitle">Need help?</h5>
          
                {(props.eSIMNumber !== undefined && props.eSIMNumber !== 'undefined' && props.eSIMNumber !== '') &&
                    <p className="card-text">
                        Your service number is: <span id="simNumber" className="user-text">{(props.eSIMNumber)}</span>
                    </p>
                }
                <p className="card-text down-text" id="troubleMsg">
                    Before we troubleshoot your eSIM, please check the following:
                </p>
                <p className="card-text">
                    <strong>1.&nbsp; Your credit balance: </strong>
                    <p className="down-text">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Check the balance of your service by signing into&nbsp;
                        <a href="https://www.my.telstra.com.au/myaccount/home" target="_blank" id="t247">Telstra 24x7 My Account</a>
                    </p>
                </p>
                <p className="card-text">
                    <strong>2.&nbsp; Network coverage: </strong>
                    <p className="down-text">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Find out what&nbsp;
                        <a href="https://www.telstra.com.au/coverage-networks/our-coverage" target="_blank" id="cover">coverage</a>&nbsp;is available in your area.
                    </p>
                </p>

                <p className="card-text">
                    <strong>3.&nbsp; Current outages: </strong>
                    <p className="down-text">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Check if your location is currently affected by a&nbsp;
                        <a href="https://outages.telstra.com.au/" target="_blank" id="outage">network outage or maintainence</a>
                    </p>
                </p>

                <button id="btnDownload" className="button-primary btn-text" onClick={props.clickEvt}>{props.buttonText}</button>

            </div>

        </div>
    );

};

export default DownloadCard;



// WEBPACK FOOTER //
// ./src/components/cards/DownloadCard.tsx